module.exports = __webpack_public_path__ + "static/img/img45.2b27f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img45.png
// module id = 4q7/
// module chunks = 1